// extracted by mini-css-extract-plugin
export default {"skeleton":"SkeletonLines_skeleton__RKZwB"};